<template>
  <div class="main page-admin-users-log">
    <Sidebar :current-keywords="keywords" @search="setKeywords">
      <div slot="custom-filters" class="custom-filters date-filters row">
        <div class="col-12 mb-3">
          <Field type="datepicker" name="start_date" label="Start Date" v-model="startDate" />
        </div>
        <div class="col-12 mb-3">
          <Field type="datepicker" name="end_date" label="End Date" v-model="endDate" />
        </div>
      </div>
    </Sidebar>

    <div class="title-bar">
      <h1 class="mb-0">Account History for {{ user.name }}</h1>
      <a class="btn-back" href="javascript:history.go(-1);">
        <span class="icon icon-arrow-left"></span>
        <span class="text">Go Back</span>
      </a>
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
                @item-clicked="setSelectedItem"
              >
                <template v-slot:col_attribute="{ item }">{{ item.attribute_label || '' }}</template>
                <template
                  v-slot:col_updated_at="{ item }"
                >{{ item.updated_at | moment('MM/DD/YYYY') }}</template>
              </ListTable>
            </div>
          </div>
          <div class="row">
            <div class="d-none d-xl-flex col-xl-3"></div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize :value="parseInt(pagination.per_page)" @input="setPerPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  props: {
    user: { type: Object, required: true }
  },
  data() {
    return {
      startDate: null,
      endDate: null
    };
  },
  watch: {
    startDate(val) {
      if (!!val) {
        this.replaceFilter("start_date", val);
      } else {
        this.clearFilter("start_date");
      }
    },
    endDate(val) {
      if (!!val) {
        this.replaceFilter("end_date", val);
      } else {
        this.clearFilter("end_date");
      }
    }
  }
};
</script>
